import xihoumen from "./index.vue";
import xihoumenHome from "./Home.vue";
import SteelBox from "../hangzhouwan/steelBox.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const errorRecord = ()=>import("./../../components/ErrorRecordControl.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");
const stationSteelbox = () => import("./steelbox.vue")
const gasClamp = () => import("./gasClamp.vue")


export default [
  {
    path: "/xihoumenFreshAirIndex",
    name: "xihoumenFreshAirIndex",
    component: xihoumenHome
  },
  {
    path: "/xihoumenFreshAir/login",
    name: "xihoumenFreshAirLogin",
    component: login
  },

  {
    path: "/xihoumenFreshAir",
    name: "xihoumenFreshAir",
    redirect: "/xihoumenFreshAir",
    component: xihoumen,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
      {
        path: "gasClamp",
        name: "gasClamp",
        component: gasClamp
      },
      {
        path: "steelbox",
        name: "steelbox",
        component: stationSteelbox
      },
    ]
  }
];
